// extracted by mini-css-extract-plugin
export default {"monitoring-skeleton__container":"styles_monitoring-skeleton__container__uMw9q"};